import Include from "@components/documentation/api.mdx";
import Wrapper from "@components/documentation/components/Wrapper";

export default function Page() {
  return (
    <Wrapper>
      <Include />
    </Wrapper>
  );
}
